import {Circle, Fill, RegularShape, Icon, Stroke, Style, Text} from 'ol/style';

export const MapStyles = {
	highlight: new Style({
        fill: new Fill({
            color: 'rgba(255, 21, 21, 0.4)'
        }),
        stroke: new Stroke({
            color: '#FF1515',
            width: 4
        }),
        image: new Circle({
            radius: 7,
            fill: new Fill({
                color: '#FF1515'
            })
        })
    }),

	/*
		* Stili custom (Minimappa)
		*/
	/*
		* es: PGRA
		*/
	featurePoligoni: new Style({
		// Stile per punti
		image: new Circle({
			radius: 3,
			stroke: new Stroke({
				color: "#ff0707",
				width: 3
			}),
			fill: new Fill({
				color: "rgba(255, 7, 7, 0.5)"
			})
		}),
		
		// Stile bordi ( linee e poligoni )
		stroke: new Stroke({
			color: '#ff0707',
			width: 1
		}),
		
		// Stile riempimento (poligoni)
		fill: new Fill({
			color: "rgba(255, 7, 7, 0.1)"
		})
	}),

	nodi: function(feature, resolution) {
		let image = new RegularShape({
			fill: new Fill({
				color: 'rgba(255, 21, 21, 0.8)'
			}),
			stroke: new Stroke({
				color: "#ff0707",
				width: 1
			}),
			points: 4,
			radius: 10,
			angle: 0
		});

		if(resolution > 0.5) {
			image = new Circle({
				radius: 7,
				fill: new Fill({
					color: 'rgba(255, 21, 21, 0.8)'
				}),
				stroke: new Stroke({
					color: "#ff0707",
					width: 2
				})
			})
		}

		let style = new Style({
			image: image
		});
		return style;
	},

	featurePoligoniPgraFn: function(feature, resolution) {
		var styleProp = {
			// Stile per punti
			image: new Circle({
				radius: 3,
				stroke: new Stroke({
					color: "#ff0707",
					width: 3
				}),
				fill: new Fill({
					color: "rgba(255, 7, 7, 0.5)"
				})
			}),
			
			// Stile bordi ( linee e poligoni )
			stroke: new Stroke({
				color: '#ff0707',
				width: 1
			}),
			
			// Stile riempimento (poligoni)
			fill: new Fill({
				color: "rgba(255, 7, 7, 0.1)"
			})
		};
		
		if (resolution <= 200 ) {
			
			var textProp = {
				overflow: true,
				font: '14px Calibri,sans-serif',
				fill: new Fill({color: "#ffffff"}),
				stroke: new Stroke({color: "#000000", width: 3}),
				text: feature.getProperties().pagename,
				placement: "point",
//			        offsetY: -15,
				backgroundFill: new Fill({color: "rgba(255, 255, 255, 0)"})
			};
			
			if (resolution <= 100) {
				textProp.font = '16px Calibri,sans-serif';
			}
			
			if (resolution <= 80) {
				textProp.font = '18px Calibri,sans-serif';
			}
			
			styleProp.text = new Text(textProp);
		}
		
		var style = new Style(styleProp);
		
		return style; 
	},

	featurePoligoniDtmFn: function(feature, resolution) {
		var styleProp = {
			// Stile per punti
			image: new Circle({
				radius: 3,
				stroke: new Stroke({
					color: "#ff0707",
					width: 3
				}),
				fill: new Fill({
					color: "rgba(255, 7, 7, 0.5)"
				})
			}),
			
			// Stile bordi ( linee e poligoni )
			stroke: new Stroke({
				color: '#ff0707',
				width: 1
			}),
			
			// Stile riempimento (poligoni)
			fill: new Fill({
				color: "rgba(255, 7, 7, 0.1)"
			})
		};
		
		if (resolution <= 14 ) {
			
			var textProp = {
				overflow: true,
				font: '14px Calibri,sans-serif',
				fill: new Fill({color: "#ffffff"}),
				stroke: new Stroke({color: "#000000", width: 3}),
				text: feature.getProperties().cod_grid,
				placement: "point",
//			        offsetY: -15,
				backgroundFill: new Fill({color: "rgba(255, 255, 255, 0)"})
			};
			
			if (resolution <= 70) {
				textProp.font = '16px Calibri,sans-serif';
			}
			
			if (resolution <= 80) {
				textProp.font = '18px Calibri,sans-serif';
			}
			
			styleProp.text = new Text(textProp);
		}
		
		var style = new Style(styleProp);
		
		return style; 
	},

	featureLineeSezioniFn: function(feature, resolution) {
		var styleProp = {
			// Stile per punti
			image: new Circle({
				radius: 3,
				stroke: new Stroke({
					color: "#ff0707",
					width: 3
				}),
				fill: new Fill({
					color: "rgba(255, 7, 7, 0.5)"
				})
			}),
			
			// Stile bordi ( linee e poligoni )
			stroke: new Stroke({
				color: '#ff0707',
				width: 2
			}),
			
			// Stile riempimento (poligoni)
			fill: new Fill({
				color: "rgba(255, 7, 7, 0.1)"
			})
		};
		
		if (resolution <= 14 ) {
			
			var textProp = {
				overflow: true,
				font: '14px Calibri,sans-serif',
				fill: new Fill({color: "#ffffff"}),
				stroke: new Stroke({color: "#000000", width: 3}),
				text: feature.getProperties().cod_sezion,
				placement: "point",
//			        offsetY: -15,
				backgroundFill: new Fill({color: "rgba(255, 255, 255, 0)"})
			};
			
			if (resolution <= 70) {
				textProp.font = '16px Calibri,sans-serif';
			}
			
			if (resolution <= 80) {
				textProp.font = '18px Calibri,sans-serif';
			}
			
			styleProp.text = new Text(textProp);
		}
		
		var style = new Style(styleProp);
		
		return style; 
	},

	featureFiumeSelezionatoFn: function(feature, resolution) {
		var styleProp = {
			// Stile bordi ( linee e poligoni )
			stroke: new Stroke({
				color: '#0a0e63',
				width: 5
			}),
		};
		
		var style = new Style(styleProp);
		
		return style; 
	},
	
};